import { createOverlay } from '@vfde-brix/ws10/overlay';
import { DEFAULT_OVERLAY_CONTAINER_ID } from 'Container/App/constants';
import {
    closeOverlay,
    fetchOverlay,
    injectOverlayContent,
    openOverlay,
    selectOverlayContextForUrl,
    selectOverlayUrl,
} from '@vfde-sails/overlay';
import { useDispatch } from '../store';
import { startAppListening } from 'Container/App/listener';
import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { mountOverlayButtons } from './Button';
import {
    TRACKING_INFORMATION_ACTION_REVEAL,
    TrackingInformationTrigger,
    TrackingInformationUiType,
    trackIt,
    TrackType,
} from '@vfde-sails/tracking';

/**
 * Overlay
 */
export default function mountOverlay (): void {
    const dispatch = useDispatch();

    let container = document.getElementById(DEFAULT_OVERLAY_CONTAINER_ID);

    if (!container) {
        container = document.createElement('div');
        container.id = DEFAULT_OVERLAY_CONTAINER_ID;

        document.body.appendChild(container);
    }

    const overlay = createOverlay(container, {
        optPaddingLayout: true,
        business: {
            onOpen: () => {
                dispatch(openOverlay());
            },
            onClose: () => {
                dispatch(closeOverlay());
            },
            onInject: () => {
                dispatch(injectOverlayContent());
            },
        },
    });

    startAppListening({
        actionCreator: fetchOverlay.fulfilled,
        effect: action => {
            if (action.payload.content) {
                overlay.injectContent(action.payload.content);
            }
        },
    });

    startAppListening({
        actionCreator: injectOverlayContent.fulfilled,
        effect: (_action, api) => {
            const url = selectOverlayUrl(api.getState());

            if (url?.includes(window[ADDITIONAL_PAGE_OPTIONS].offerSummaryCard.gigakombiOverlay)) {
                // Mount buttons in GK overlay
                mountOverlayButtons(overlay);
            }

            overlay.open();
        },
    });

    startAppListening({
        actionCreator: openOverlay,
        effect: (_action, api) => {
            const context = selectOverlayContextForUrl(api.getState());

            if (context?.trackingData) {
                trackIt(TrackType.Information, {
                    /* eslint-disable camelcase, @typescript-eslint/naming-convention */
                    information_action: TRACKING_INFORMATION_ACTION_REVEAL,
                    information_name: context.trackingData.trackingName,
                    information_ui_type: TrackingInformationUiType.Overlay,
                    information_trigger: TrackingInformationTrigger.Anchor,
                    /* eslint-enable camelcase, @typescript-eslint/naming-convention */
                });
            }
        },
    });
}
